var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsSix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 8.125C5.20527 8.125 5.625 7.70527 5.625 7.1875C5.625 6.66973 5.20527 6.25 4.6875 6.25C4.16973 6.25 3.75 6.66973 3.75 7.1875C3.75 7.70527 4.16973 8.125 4.6875 8.125Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99805 8.125C10.5158 8.125 10.9355 7.70527 10.9355 7.1875C10.9355 6.66973 10.5158 6.25 9.99805 6.25C9.48028 6.25 9.06055 6.66973 9.06055 7.1875C9.06055 7.70527 9.48028 8.125 9.99805 8.125Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 8.125C15.8303 8.125 16.25 7.70527 16.25 7.1875C16.25 6.66973 15.8303 6.25 15.3125 6.25C14.7947 6.25 14.375 6.66973 14.375 7.1875C14.375 7.70527 14.7947 8.125 15.3125 8.125Z",
    fill: "#1A181E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 13.75C5.20527 13.75 5.625 13.3303 5.625 12.8125C5.625 12.2947 5.20527 11.875 4.6875 11.875C4.16973 11.875 3.75 12.2947 3.75 12.8125C3.75 13.3303 4.16973 13.75 4.6875 13.75Z",
    fill: "#1A181E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99805 13.75C10.5158 13.75 10.9355 13.3303 10.9355 12.8125C10.9355 12.2947 10.5158 11.875 9.99805 11.875C9.48028 11.875 9.06055 12.2947 9.06055 12.8125C9.06055 13.3303 9.48028 13.75 9.99805 13.75Z",
    fill: "#1A181E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 13.75C15.8303 13.75 16.25 13.3303 16.25 12.8125C16.25 12.2947 15.8303 11.875 15.3125 11.875C14.7947 11.875 14.375 12.2947 14.375 12.8125C14.375 13.3303 14.7947 13.75 15.3125 13.75Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsSix);
export default __webpack_public_path__ + "static/media/dots-six.112e1f68b42b91b4852e9c4bf24b71df.svg";
export { ForwardRef as ReactComponent };